import React from "react";
import { createRoot } from "react-dom/client";
import { setupIonicReact } from "@ionic/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App.jsx";

import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "./theme/variables.css";
import "./theme/app.css";

setupIonicReact({ mode: "ios" });

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || "missing-client-id"}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
